import { render, staticRenderFns } from "./USTradePanel.vue?vue&type=template&id=c3c338be&scoped=true"
import script from "./USTradePanel.vue?vue&type=script&lang=js"
export * from "./USTradePanel.vue?vue&type=script&lang=js"
import style0 from "./USTradePanel.vue?vue&type=style&index=0&id=c3c338be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c338be",
  null
  
)

export default component.exports